/**
 * tenant-css.js — Per-winery CSS, concatenated in injection order.
 *
 * Split out of core/init.js so every shadow root the widget owns gets the same
 * tenant overrides: the main widget root AND the host-page search bar's own
 * root (features/optional/search-bar.js). A variant themes both from its single
 * `variants/<slug>/styles.css` via `:host(.ws-tenant-<slug>)`, because both
 * hosts carry that class.
 *
 * Injected AFTER variables.css + cards.css so each tenant's overrides win.
 * Order matters only for valle/hestan (they override the shared rich-card
 * scaffold); tenants are mutually exclusive, so the rest is order-independent.
 */

import fogartyCSS from '../variants/fogartywinery/styles.css';
import goosecrossCSS from '../variants/goosecross/styles.css';
import valledellapaceCSS from '../variants/valledellapace/styles.css';
import hestanvineyardsCSS from '../variants/hestanvineyards/styles.css';
import halleckvineyardCSS from '../variants/halleckvineyard/styles.css';
import wineengineCSS from '../variants/wineengine/styles.css';
import lightningrockwineryCSS from '../variants/lightningrockwinery/styles.css';
import pottersvineyardCSS from '../variants/pottersvineyard/styles.css';

export const TENANT_CSS = [
  fogartyCSS,
  goosecrossCSS,
  valledellapaceCSS,
  hestanvineyardsCSS,
  halleckvineyardCSS,
  wineengineCSS,
  lightningrockwineryCSS,
  pottersvineyardCSS,
].join("\n");
